import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  charities: localStorage.getItem('charities') && JSON.parse(localStorage.getItem('charities'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/charities/index.js